{
  "uigCartDetails": {
    "proceedToCheckout": "Bestellen",
    "cartName": "Warenkorb #{{code}}"
  },
  "uigCartItems": {
    "id": "Art.Nr.:",
    "le": "LE:",
    "description": "Produktinfo",
    "itemPrice": "Einzelpreis",
    "quantity": "Anzahl",
    "total": "Gesamtpreis",
    "products": "Art."
  },
  "fastEntry": {
    "title": "Schnelleingabe",
    "hint": "Hier k\u00F6nnen Sie Artikel direkt eingeben.",
    "errors": {
      "invalidCode": "Es konnte kein Artikel f\u00FCr die Artikelnummer \"{{productCode}}\" gefunden werden.",
      "zeroQty": "Art.Nr.: {{productCode}} - Verkauf aufgrund vom Verkaufsmengenlimit nicht mehr möglich.",
      "notesMaxLength": "Art.Nr.: {{productCode}} - Notiz konnte nicht hinzugefügt werden. Maximale Länge wurde erreicht.",
      "notListed": "Art.Nr.: {{productCode}} - Das Produkt ist für Sie nicht gelistet."
    },
    "placeholders": {
      "articleNo": "Art. Nr.",
      "quantity": "0",
      "note": "Notiz"
    },
    "buttons": {
      "submit": "Artikel hinzufügen"
    },
    "addEntryConfirmation": "Der Artikel wurde erfolgreich in den Warenkorb gelegt."
  },
  "cartWishlist": {
    "title": "MERKZETTEL",
    "submit": "In den Warenkorb",
    "empty": "Aktuell sind keine Produkte in Ihrem Merkzettel enthalten."
  },
  "notes": {
    "noteAdd": "Positionsnotiz anlegen",
    "noteLabel": "Notiz:",
    "modalTitle": "Artikelnotiz hinzufügen oder ändern",
    "edit": "Notiz bearbeiten:",
    "save": "Speichern",
    "errorLabel": "Error: \"{{errMsg}}\"",
    "updateSuccess": "Notiz wurde erfolgreich aktualisiert!"
  },
  "shippingNote": {
    "label": "Hinweis:",
    "text": "ab 450,00 Bestellwert keine Versandkosten!"
  },
  "productImport": {
    "importTitle": "Produkte importieren",
    "importText": "Hier k\u00F6nnen Sie Bestelldaten aus einer vorher erstellten Datei \u00FCbernehmen.",
    "noFileSelected": "Keine ausgew\u00E4hlt",
    "buttons": {
      "import": "Jetzt Importieren",
      "select": "Datei auswählen"
    },
    "importSuccess": "Alle Produkte erfolgreich \u00FCbernommen."
  },
  "cartExport": {
    "cartFilename": "Warenkorb",
    "errorExportCart": "Der Warenkorb konnte nicht exportiert werden."
  },
  "addToCartLayer": {
    "goToCart": "Zum Warenkorb gehen",
    "removeItem": "Artikel wieder aus Warenkorb löschen"
  },
  "emptyCart": {
    "deleteAll": "Alle Artikel im Warenkorb löschen?",
    "yes": "Ja",
    "no": "Nein",
    "error": "Produkte im Warenkorb konnten nicht gelöscht werden.",
    "title": "Warenkorb leeren",
    "noEntries": "Ihr Warenkorb ist schon leer."
  },
  "vendorGroups": {
    "orderTotal": "Bestellung gesamt",
    "vendor": "Lieferant",
    "numberOfEntries": "Anzahl Positionen",
    "numberOfPieces": "Anzahl Stück gesamt",
    "cartTotal": "Warenwert gesamt",
    "vendorTotal":"Warenwert",
    "deliveryCost": "zzgl. Frachtkosten",
    "note": "Hinweis"
  }
}
